import { render, staticRenderFns } from "./FormulaComponent.vue?vue&type=template&id=6575ec97"
import script from "./FormulaComponent.vue?vue&type=script&lang=js"
export * from "./FormulaComponent.vue?vue&type=script&lang=js"
import style0 from "./FormulaComponent.vue?vue&type=style&index=0&id=6575ec97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports